import React, { useState, useEffect } from "react";
import "./Home.scss";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLatestNotifications } from "../../Redux/ActionCreators/dashboardAction";
import { formatNotification } from "../../utils/notificationFormatter";

const Livefeed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notificationTrigger } = useOutletContext();

  const { notifications = [], pagination = {} } = useSelector(
    (state) => state.dashboard
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const pageSize = 10;

  const fetchNotifications = async (page = 1) => {
    try {
      setLoading(true);
      await dispatch(getLatestNotifications({ page, page_size: pageSize }));
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchNotifications(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (notificationTrigger) {
      fetchNotifications(1);
      setCurrentPage(1);
    }
  }, [notificationTrigger]);

  const totalPages = Math.ceil((pagination.total || 0) / pageSize);

  const renderCustomPagination = (totalPages, currentPage, setCurrentPage) => {
    const pagination = [];

    pagination.push(
      <button
        key="prev"
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <img src="/images/leftarrow-icon.svg" alt="" />
      </button>
    );

    pagination.push(
      <button
        key={1}
        className={currentPage === 1 ? "active" : ""}
        onClick={() => setCurrentPage(1)}
      >
        {1}
      </button>
    );

    if (currentPage > 3) {
      pagination.push(<button key="left-dots">...</button>);
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pagination.push(
        <button
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>
      );
    }

    if (currentPage < totalPages - 2) {
      pagination.push(<button key="right-dots">...</button>);
    }

    if (totalPages > 1) {
      pagination.push(
        <button
          key={totalPages}
          className={currentPage === totalPages ? "active" : ""}
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    pagination.push(
      <button
        key="next"
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <img
          src="/images/leftarrow-icon.svg"
          alt=""
          style={{ rotate: "180deg" }}
        />
      </button>
    );

    return pagination;
  };


  return (
    <div className="dashboard" style={{paddingBottom:'75px'}}>
      <div>
        <h1
          style={{
            fontSize: "22px",
            lineHeight: "30px",
            fontWeight: "600",
            cursor: "pointer",
          }}
          onClick={() => navigate("/dashboard")}
        >
          <img src="/images/leftarrow-black-icon.svg" alt="" />
          &nbsp;Dashboard
        </h1>
      </div>
      <div className="live-feed-plan">
        <div className="live-feed" style={{ width: "100%", background: 'unset', padding:'unset' }}>
          <div className="feeds">
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : notifications.length ? (
              notifications.map(notif => {
                const { id, timeAgo, message, icon, bgColor, to } = formatNotification(notif);
                return (
                  <div key={id} className="feed-items">
                    <div className="icon" style={{ background: bgColor }}>
                      <img src={icon} alt="" />
                    </div>
                    <div className="feed-text live-page">
                      <p style={{ fontSize: "12px", color: '#0000008A' }}>{timeAgo}</p>
                      <p>{message}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end" style={{ width: "10%" }}>
                      <button onClick={() => navigate(to)}>
                        <img src="/images/circle-right-black.svg" alt="" />
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-muted text-center py-3">No recent notifications</div>
            )}
          </div>
        </div>
      </div>
        <div className="pagination">
          <div className="pagination-info">
            {pagination.total ? (
              <span>
                Showing <strong>{(currentPage - 1) * pageSize + 1}</strong>-
                <strong>{Math.min(currentPage * pageSize, pagination.total)}</strong> of <strong>{pagination.total}</strong>
              </span>
            ) : (
              <span>Showing 0-0 of 0</span>
            )}
          </div>
          <div className="pagination-buttons">
            {renderCustomPagination(totalPages, currentPage, setCurrentPage)}
          </div>
        </div>
    </div>
  );
};

export default Livefeed;
